import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ChevronRightIcon, XMarkIcon } from '@heroicons/react/24/outline';
import cn from 'classnames';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import LINK from 'constants/link.const';
import useIsMobileViewport from 'hooks/useIsMobileViewport.hook';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { useTheme } from 'providers/Theme.provider';
import linkTo from 'utils/links/linkTo.util';

import { FORM_TEMPLATES } from '../consultationForms.const';

import CN from './NewFormTemplateModal.module.scss';

export const NewFormTemplateModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const salonId = useCurrentSalonId();
  const { isDarkMode } = useTheme();
  const isMobile = useIsMobileViewport();

  const handleSelectTemplate = (template) => {
    onClose();
    const path = linkTo({ pattern: LINK.settingsFormBuilder, params: { salonId } });
    history.push(`${path}?template=${template.id}`);
  };

  return (
    <SalonModal tag="NewFormTemplateModal" isOpen={isOpen} noFooter onClose={onClose} fullWidth={!isMobile} customClass={cn(CN.modalDialog, { [CN.darkMode]: isDarkMode })}>
      <SalonModal.Header>
        <div data-bem="NewFormTemplateModal__header" className={CN.modalHeader}>
          <Button variant="icon" tag="NewFormTemplateModal__close" className={CN.closeButton} onClick={onClose}>
            <XMarkIcon className={CN.closeIcon} />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={CN.heading}>
          <h2 className={CN.title}>{t('consultationForms.templateModal.title')}</h2>
          <p className={CN.subtitle}>{t('consultationForms.templateModal.subtitle')}</p>
        </div>
        <ul data-bem="NewFormTemplateModal__list" className={CN.templateList}>
          {FORM_TEMPLATES.map((template) => (
            <li key={template.id}>
              <button data-bem="NewFormTemplateModal__row" type="button" className={CN.templateRow} onClick={() => handleSelectTemplate(template)}>
                <span className={CN.iconWrap}>{template.icon}</span>
                <span className={CN.info}>
                  <span className={CN.topLine}>
                    <span className={CN.name}>{t(template.nameKey)}</span>
                    {template.questionCount > 0 && <span className={CN.questionsBadge}>{t('consultationForms.questionsCount', { count: template.questionCount })}</span>}
                  </span>
                  <span className={CN.subtext}>{t(template.subtitleKey)}</span>
                </span>
                <ChevronRightIcon className={CN.templateRowChevron} />
              </button>
            </li>
          ))}
        </ul>
      </SalonModal.Body>
    </SalonModal>
  );
};
